<div class="ui raised segment margin-bottom-10">
    <div class="ui stackable grid">
        <div class="four wide column">
            <img src="{{employee.picture}}" class="image">
        </div>
        <div class="six wide column employee-data">
            <h3>{{employee.name}}</h3>
            <p>{{employee.job}}</p>
        </div>
        <div class="six wide column">
            <button class="ui negative button remove-button" (click)="remove()">Supprimer</button>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/employees/employee/employee.html